import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { PracticeTranslationsQueryDocument } from '@docpace/manager-graphql/dist/urql.types'
import { PracticeTranslationsQueryResultFragment, PracticeTranslationsQueryParams } from '@docpace/manager-graphql'

const typedPracticeTranslationsQueryDocument = PracticeTranslationsQueryDocument as TypedDocumentNode<PracticeTranslationsQueryResultFragment, Partial<PracticeTranslationsQueryParams>>

export function usePracticeTranslationsQuery(opts?: useQuery.Options<PracticeTranslationsQueryResultFragment, Partial<PracticeTranslationsQueryParams>>){
    return useQuery(typedPracticeTranslationsQueryDocument, opts)
}